/* CheckoutFormSubscription.js */
/* @author: anghello */

import React, { useCallback, useEffect, useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import Strings from "../../../translations/Translations";
import { useAuth } from "../../../Context/Auth/AuthContext";
import { Alert, Button } from "reactstrap";

const paymentElementOptions = { layout: "tabs" }

export default function CheckoutFormSubscription({ callback }) {
  const { toggleLoading } = useAuth();

  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded
      return;
    }

    toggleLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    });

    toggleLoading(false);

    if ((error && error.type === 'card_error') || (error && error.type === 'validation_erro')) {
      toast.error(error.message);
    } else if (error) {
      toast.error(Strings('an_unexpected_error_occurred'));
    } else {
      toast.success(Strings('success'));

      if (callback) {
        callback();
      }
    }
  }, [elements, stripe, callback, toggleLoading]);

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement options={paymentElementOptions} />
      <div className='d-flex justify-content-end mt-3'>
        <Button color="primary" disabled={!stripe || !elements}>
          {Strings('pay_now')}
        </Button>
      </div>

      <div>
        {message && <Alert>{message}</Alert>}
      </div>
    </form>
  );
}
